import type { CourseLanguageState } from './types';

export const initialCourseLanguageState: CourseLanguageState = {
  courseLanguageById: {}
};
